import { Defaults } from '@pbt/pbt-ui-components'

import { getPreludeAPIPath, request } from './core'
import * as Schema from './schemas'

export const fetchInventoryItemTrackingForVariation = (
  businessId: string,
  variationId: string,
  from = 0,
  to = Defaults.INFINITE_LIST_BATCH_LOAD_COUNT,
) =>
  request(
    getPreludeAPIPath(
      `inventory-integration/item/tracking/variation/${variationId}`,
    ),
    { method: 'GET', params: { businessId, from, to } },
    true,
    Schema.inventoryItemTrackingList,
  )

export const fetchInventoryItemTrackingForVaccine = (
  businessId: string,
  procedureId: string,
  from = 0,
  to = Defaults.INFINITE_LIST_BATCH_LOAD_COUNT,
) =>
  request(
    getPreludeAPIPath(
      `inventory-integration/item/tracking/vaccination/${procedureId}`,
    ),
    { method: 'GET', params: { businessId, from, to } },
    true,
    Schema.inventoryItemTrackingList,
  )

export const fetchInventoryItemTrackingForVaccineWithVariation = (
  businessId: string,
  procedureId: string,
  from: number,
  to: number,
  includeExpiredItems: boolean,
) =>
  request(
    getPreludeAPIPath(
      `inventory-integration/item/tracking/vaccination/${procedureId}/withVariation`,
    ),
    {
      method: 'GET',
      params: {
        businessId,
        from,
        to,
        showExpired: includeExpiredItems,
      },
    },
    true,
    Schema.inventoryItemTrackingList,
  )
